import { isValidObject } from '@/helpers/common/validationHelper'
import type { StdTelemetry, TelemetryMeasurement, TelemetrySensor } from '@/types/devices'
import type { FormattedMeasurement } from '@/services/device-service/devices'

export const getDeviceStatusFormattedResponse = (readings: StdTelemetry): string[] => {
  return readings?.system_status_messages || []
}

export const hasLatestStudyErrorState = (
  errorName: string,
  latestErrorState: string[]
): boolean => {
  if (errorName && Array.isArray(latestErrorState)) {
    return latestErrorState.includes(errorName)
  }
  return false
}

const getFormattedSensorMeasurements = (
  measurements: Record<string, TelemetryMeasurement>,
  sensorKey: string
): Record<string, FormattedMeasurement> => {
  const formattedMeasurements: Record<string, FormattedMeasurement> = {}
  if (isValidObject(measurements)) {
    Object.keys(measurements).forEach((measurementKey) => {
      const measurement = measurements[measurementKey]
      if (isValidObject(measurement)) {
        formattedMeasurements[measurementKey] = {
          timestamp: measurement.timestamp,
          value: measurement.value,
          type: sensorKey
        }
      }
    })
  }
  return formattedMeasurements
}

const getFormattedSensorStatusMessages = (
  sensorStatusMessages: string[] | null | undefined
): string[] => {
  return sensorStatusMessages?.length ? sensorStatusMessages : []
}

export interface FormattedSensorData {
  measurements: Record<string, FormattedMeasurement>
  sensorStatus: string[]
}

export const getFormattedSensorData = (
  sensors: Record<string, TelemetrySensor> | null | undefined
): FormattedSensorData => {
  const formattedData: FormattedSensorData = {
    measurements: {},
    sensorStatus: []
  }
  if (isValidObject(sensors)) {
    Object.keys(sensors).forEach((sensorKey) => {
      const sensorData = sensors[sensorKey]
      if (isValidObject(sensorData)) {
        formattedData.sensorStatus = formattedData.sensorStatus.concat(
          getFormattedSensorStatusMessages(sensorData.status_messages)
        )
        formattedData.measurements = {
          ...formattedData.measurements,
          ...getFormattedSensorMeasurements(sensorData.measurements, sensorKey)
        }
      }
    })
  }

  return formattedData
}
